// extracted by mini-css-extract-plugin
export default {"App":"App_App__GKK58","App-logo":"App_App-logo__YIqNJ","App-logo-spin":"App_App-logo-spin__gtnSc","App-header":"App_App-header__mSaHj","App-link":"App_App-link__RxUxt"};